import { TFunction } from "i18next";
import * as Yup from "yup";

export const getOrganizationalStructureFormSchema = (t: TFunction) =>
    Yup.object().shape({
        code: Yup.string()
            .trim()
            .required(t("common:form.requiredFieldForm")),
        name: Yup.object()
            .shape({
                catalan: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
                spanish: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
                english: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
            })
            .required(t("common:form.requiredFieldForm")),
        parentId: Yup.number()
            .nullable()
            .when("id", {
                is: 0,
                then: schema =>
                    schema.required(t("common:form.requiredFieldForm")),
                otherwise: schema => schema.notRequired()
            })
    });
